(function($, undefined) {
	"use strict";

	let utils;
	let formValidator;
	
	function init() {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		$('.nfc-popup-btn').on("click", populatePopup);
		$('.nfc-popup__input[name="field5"]').on('change', populateQuestions);
		$('#nfc-popup-form').on('submit', saveNFC);
		
		$(document).on("click",".delete-selected-nfcs",deleteSelectedCheckboxes);
		$(document).on("click","#include-select-all",selectAllCheckbox);
		$(document).on("change",".nfc-checkbox",function(e){
			$("#include-select-all").prop("checked",$('.nfc-checkbox:checkbox:checked').length==$(".nfc-checkbox:checkbox").length);
			var popupConfirmBtn = $(`.delete-selected-nfcs`);
			
			if($('.nfc-checkbox:checkbox:checked')!=undefined && $('.nfc-checkbox:checkbox:checked').length>0){
				popupConfirmBtn.attr("data-id","delete-nfc-popup");
			}else popupConfirmBtn.removeAttr("data-id");
		});
	}

	function deleteSelectedCheckboxes(e){
		var deleteAllPopup=$(`.delete-selected-nfcs`);
		if($('.nfc-checkbox:checkbox:checked')!=undefined && $('.nfc-checkbox:checkbox:checked').length>0){
			var ids="";

			$('.nfc-checkbox:checkbox').each((i,v)=>{
				if($(v).prop("checked"))
					ids+=(ids==""?"":",")+$(v).attr("data-item-id");
			});

			deleteAllPopup.attr("data-item-id",ids);

			const { id } = e.currentTarget.dataset;
			var popupConfirmBtn = $(`.stool-shared-popup[data-id="${id}"] .confirm-delete`);
			
			if (popupConfirmBtn && popupConfirmBtn.length){
				Object.assign(popupConfirmBtn[0].dataset, e.currentTarget.dataset);
			}
		}else {
			deleteAllPopup.attr("data-item-id","");
			alert("Please select any NFC(s) to delete");
		}
	}

	function selectAllCheckbox(e){
		$(".nfc-checkbox").prop("checked",e.currentTarget.checked);
		
		if(e.currentTarget.checked)
			$(`.delete-selected-nfcs`).attr("data-id","delete-nfc-popup");
		else $(`.delete-selected-nfcs`).removeAttr("data-id");
	}

	function populatePopup({ currentTarget }) {
		const { id, itemId,type, show, targetSelector, allSelector } = currentTarget.dataset;
		
		const popup = $(`.stool-shared-popup[data-id="${id}"]`);
		const cancel = $('.popup-cancel', popup);
		const field6 = $(currentTarget).attr("data-item-field6");
		const form = document.getElementById("nfc-popup-form");
		
		if (form) {
			form.dataset.target = targetSelector;
			form.dataset.all = allSelector;
		}

		if (show) {
			$('.nfc-popup__input-ctn_hide', popup)
				.removeClass('nfc-popup__input-ctn_hide')
				.addClass('nfc-popup__input-ctn_to-hide');
			$('[name="field5"],[name="field6"]').addClass('required');
		} else {
			$('.nfc-popup__input-ctn_to-hide', popup)
				.removeClass('nfc-popup__input-ctn_to-hide')
				.addClass('nfc-popup__input-ctn_hide');
			$('[name="field5"],[name="field6"]').removeClass('required');
		}

		if (itemId || type=="single") {
			$("#add-series").parent().addClass("d-none").removeClass("d-block");
			utils.fetchGenDatas({ids: itemId}, (data) => {
				populateFields(data[0], popup);
				popup.removeClass('has-processing processing');
			});
		} else {
			$("#add-series").parent().addClass("d-block").removeClass("d-none");
			populateFields({field7:"true"}, popup);
		}
	}

	function populateFields(items, popup) {
		const form = popup.find('form').get(0);

		if(form && form.elements)
			Array.from(form.elements).forEach((element) => {
				const name = element.name;
				const input = $(`[name="${name}"]`, popup);

				if (input.length) {
					if (input.attr('type') == 'checkbox') {
						const value = items.hasOwnProperty(name) && items[name] != null && items[name].length ? items[name] == "true" : false;
						input.prop('checked', value);
					} else {
						const value = items.hasOwnProperty(name) && items[name] != null && items[name].length ? items[name] : input.attr('data-default');
						input.val(value);
					}
				}
			});
	}

	function populateQuestions({currentTarget}) {
		fetchQuestions(currentTarget.value, $(currentTarget).closest('.stool-shared-popup'));
	}

	function saveNFC(e) {
		const form = $(e.currentTarget);
		const popup = form.closest('.stool-shared-popup');
		const cancel = $('.popup-cancel', popup);
		const submit = $('.nfc-save-btn', popup);
		const error = $('.form-message_server-error', popup);
		
		e.preventDefault();
		
		var field4=$('[name="field4"]', form).val()==""?$('[name="field4"]', form).attr("data-default"):$('[name="field4"]', form).val();
		if($("#add-checklist-location-input").is("select"))
			field4=$("#add-checklist-location-input").find(":selected").val();
		
		const data = {
			id: $('[name="id"]', form).val(),
			field1: "nfc",
			field2: $('[name="field2"]', form).val(),
			field3: $('[name="field3"]', form).val(),
			field4: field4,
			field5: $('[name="field5"]', form).val(),
			field7: $('[name="field7"]', form).prop('checked'),
			field8: $('[name="field8"]', form).val(),
			field9: $('[name="field9"]', form).val(),
			field10: $('[name="field10"]', form).val(),
			isAddSeries:$("#add-series").prop("checked"),
			ajax: true,
		};

		var startRange;
		var endRange;
		var addZeros;
		if($("#add-series").prop("checked")){
			var prefix=$("#prefix").val() && $("#prefix").val()!=undefined && $("#prefix").val()!=""?$("#prefix").val():"";
			addZeros=$("#addZeros").val() && $("#addZeros").val()!=undefined && $("#addZeros").val()!=""?$("#addZeros").val():"";
			startRange=$("#startRange").val() && $("#startRange").val()!=undefined && $("#startRange").val()!=""?$("#startRange").val():"";
			endRange=$("#endRange").val() && $("#endRange").val()!=undefined && $("#endRange").val()!=""?$("#endRange").val():"";
			data.field2=prefix+":"+addZeros+":"+parseInt(startRange)+":"+parseInt(endRange);
		}

		$('.site-overlay').addClass('site-overlay_processing');
		cancel.hide();
		error.slideUp(300);

		formValidator.validateForm(form);
		var notValidNumber=isNaN(parseInt(startRange)) || isNaN(parseInt(endRange)) || parseInt(startRange)!=startRange || parseInt(endRange)!=endRange || parseInt(endRange)<=parseInt(startRange);
		notValidNumber=addZeros!="" && addZeros!=undefined?isNaN(parseInt(addZeros)) || parseInt(addZeros)!=addZeros || notValidNumber:notValidNumber;
		const posNum=(addZeros!="" && addZeros!=undefined && (isNaN(parseInt(addZeros)) || parseInt(addZeros)!=addZeros) || parseInt(addZeros)<1)?" add zeros should be a greater than 0":"";
		
		if(notValidNumber && $("#add-series").prop("checked"))
			alert("Please enter a valid number as start range and end range and end range should be greater than start range"+posNum);
		
		notValidNumber=$("#add-series").prop("checked")?notValidNumber:false;
		if (!form.hasClass('has-error') && !notValidNumber){
			$.ajax({
				url: '/action/manageGenData',
				type: 'POST',
				data,
				complete: (res) => onNFCSuccess(res.responseText, form, popup, data, error, submit, cancel)
			});
		} else {
			$('.site-overlay').removeClass('site-overlay_processing');
		}
	}

	function onNFCSuccess(res, form, popup, data, error, submit, cancel) {
		if (res.indexOf('success-') > -1) {
			const id = res.trim().split('success-')[1];
			const target = $(form.attr('data-target'));
			const targetDiv= $(String(form.attr('data-target')).replace(" select[name='nfc-tag']",""));
			const all = $(form.attr('data-all'));
			const refresh = $('[name="pageName"]', $('.nfc-popup'));

			if (all.length) {
				all.append(`<option value="${id}">${data.field2} (${data.field3})</option>`);
			}

			if (target.length) {
				target.val(id);
				target.trigger("change");
				if (id !== "") {
					let newItem = document.createElement('li');
					newItem.className = "checklist-form-question__nfc-list-item";
					newItem.innerHTML = `<span>${data.field2}</span><button type="button" class="js-nfc-list-item-delete" data-id="${id}">x</button>`;
					$('button', newItem).on('click', window.parent.onRemoveNFCClick);
					targetDiv.find('ul').append(newItem);
				}
				window.parent.updateNFCSelects();
			}

			if (refresh.length) {
				window.location.reload(true);
				return;
			}

			popup.removeClass('visible');
			emptyFields(popup);
			endNFCSubmit(cancel);
		} else {
			onNFCError(res, error, submit, cancel);
		}
	}

	function onNFCError(err, error, submit, cancel) {
		error.slideDown(300);
		endNFCSubmit(cancel);
	}

	function endNFCSubmit(cancel) {
		$('.site-overlay').removeClass('site-overlay_processing');
		cancel.show();
	}

	function emptyFields(popup) {
		$('input:not([type="checkbox"]), select', popup).val("");
		$('input[type="checkbox"]', popup).prop('checked', false);
	}

	function fetchChecklists(locationId, popup) {
		const fields = {
			field1: "checklist",
			field3: locationId
		};
		utils.fetchGenDatas(fields, (checklists) => {
			const select = $('select[name="field5"]', popup);
			select.find('option:not[value=""]').remove();
			
			if (checklists.hasOwnProperty("length") && typeof checklists === 'object') {
				checklists.forEach((checklist) => {
					select.append(`<option value="${checklist.id}">${checklist.field2}</option>`);
				});
			}
		});
	}

	function fetchQuestions(checklistId, popup) {
		utils.fetchGenDatas({ids: checklistId}, (checklist) => {
			const select = $('select[name="field6"]', popup);

			if (checklistId != null || checklistId == "") {
				select.removeAttr('disabled');
			} else {
				select.prop('disabled', true);
			}

			select.find('option:not[value=""]').remove();

			if (checklists.hasOwnProperty("length") && typeof checklists === 'object') {
				JSON.parse(checklist[0].field8).questions.forEach((question, i) => {
					if (!question.hasOwnProperty("NFCTag") || question.NFCTag.toString().length == 0) {
						select.append(`<option value="${id}">${question.name}</option>`);
					}
				});
			}
		});
	}
	
	$(init);
	
})(jQuery);